export class TransferTransactionModel {
  ids: Set<number> = new Set();
}



// WEBPACK FOOTER //
// ./app/lib/transfer/models/transfer_transaction_model.ts